// /* eslint-disable */
// import React from "react";
// import DualCircleProgress from "./DualCircleProgress";

// const HorizentalTileCardDual = ({ title, timeliness, accuracy, color1, color2 }) => {
//     return (
//         <div style={{
//             border: "1px solid #ddd",
//             borderRadius: "10px",
//             padding: "15px",
//             backgroundColor: "#fff",
//             width: "280px",
//             boxShadow: "0 2px 5px rgba(0,0,0,0.1)"
//         }}>
//             <p style={{
//                 fontWeight: "800",
//                 fontSize: "14px",
//                 marginBottom: "1px"
//             }}>
//                 {title}
//             </p>
//             <div style={{ display: "flex", alignItems: "center" }}>
//                 <div style={{paddingRight:"50px"}}>
//                     <div style={{ display: "flex", alignItems: "center", marginBottom: "8px" }}>
//                         <span style={{
//                             width: "8px",
//                             height: "8px",
//                             backgroundColor: "#CBD5E1",
//                             borderRadius: "50%",
//                             display: "inline-block",
//                             marginRight: "6px"
//                         }}></span>
//                         <span style={{ marginRight: "4px", fontSize:"12px", fontWeight:"600" }}>Timeliness:</span>
//                         <span style={{ color: color1, fontSize:"12px", fontWeight:"600" }}>{timeliness}%</span>
//                     </div>
//                     <div style={{ display: "flex", alignItems: "center" }}>
//                         <span style={{
//                             width: "8px",
//                             height: "8px",
//                             backgroundColor: "#CBD5E1",
//                             borderRadius: "50%",
//                             display: "inline-block",
//                             marginRight: "6px"
//                         }}></span>
//                         <span style={{ marginRight: "4px", fontSize:"12px", fontWeight:"600" }}>Accuracy:</span>
//                         <span style={{ color: color2, fontSize:"12px", fontWeight:"600" }}>{accuracy}%</span>
//                     </div>
//                 </div>
//                 <div style={{ marginLeft: "0px" }}>
//                     <DualCircleProgress
//                         timeliness={timeliness}
//                         accuracy={accuracy}
//                         color1={color1}
//                         color2={color2}
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default HorizentalTileCardDual;

// ################ Responsive code ###################
/* eslint-disable */
// import React from "react";
// import DualCircleProgress from "./DualCircleProgress";

// const HorizentalTileCardDual = ({ title, timeliness, accuracy, color1, color2 }) => {
//     return (
//         <div
//             style={{
//                 border: "1px solid #ddd",
//                 borderRadius: "10px",
//                 padding: "15px",
//                 backgroundColor: "#fff",
//                 width: "100%",
//                 maxWidth: "350px",
//                 boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
//                 display: "flex",
//                 flexDirection: "column",
//                 gap: "10px",
//             }}
//         >
//             <p
//                 style={{
//                     fontWeight: "800",
//                     fontSize: "14px",
//                     marginBottom: "2px",
//                 }}
//             >
//                 {title}
//             </p>
//             <div
//                 style={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignItems: "center",
//                     flexWrap: "wrap",
//                     gap: "10px",
//                 }}
//             >
//                 <div style={{ minWidth: "140px" }}>
//                     <div
//                         style={{
//                             display: "flex",
//                             alignItems: "center",
//                             marginBottom: "8px",
//                             flexWrap: "wrap",
//                         }}
//                     >
//                         <span
//                             style={{
//                                 width: "8px",
//                                 height: "8px",
//                                 backgroundColor: "#CBD5E1",
//                                 borderRadius: "50%",
//                                 display: "inline-block",
//                                 marginRight: "6px",
//                             }}
//                         ></span>

//                         <span
//                             style={{
//                                 marginRight: "4px",
//                                 fontSize: "12px",
//                                 fontWeight: "600",
//                             }}
//                         >
//                             Timeliness:
//                         </span>

//                         <span
//                             style={{
//                                 color: color1,
//                                 fontSize: "12px",
//                                 fontWeight: "600",
//                             }}
//                         >
//                             {timeliness}%
//                         </span>
//                     </div>
//                     <div
//                         style={{
//                             display: "flex",
//                             alignItems: "center",
//                             flexWrap: "wrap",
//                         }}
//                     >
//                         <span
//                             style={{
//                                 width: "8px",
//                                 height: "8px",
//                                 backgroundColor: "#CBD5E1",
//                                 borderRadius: "50%",
//                                 display: "inline-block",
//                                 marginRight: "6px",
//                             }}
//                         ></span>
//                         <span
//                             style={{
//                                 marginRight: "4px",
//                                 fontSize: "12px",
//                                 fontWeight: "600",
//                             }}
//                         >
//                             Accuracy:
//                         </span>
//                         <span
//                             style={{
//                                 color: color2,
//                                 fontSize: "12px",
//                                 fontWeight: "600",
//                             }}
//                         >
//                             {accuracy}%
//                         </span>
//                     </div>
//                 </div>
//                 <div
//                     style={{
//                         display: "flex",
//                         justifyContent: "center",
//                         alignItems: "center",
//                         flexShrink: 0,
//                     }}
//                 >
//                     <DualCircleProgress
//                         timeliness={timeliness}
//                         accuracy={accuracy}
//                         color1={color1}
//                         color2={color2}
//                     />
//                 </div>
//             </div>
//         </div>
//     );
// };

// export default HorizentalTileCardDual;


// ################# 

import React from "react";
import DualCircleProgress from "./DualCircleProgress";

const HorizentalTileCardDual = ({ title, timeliness, accuracy, color1, color2 }) => {
    return (
        <div
            style={{
                border: "1px solid #ddd",
                borderRadius: "10px",
                padding: "15px",
                backgroundColor: "#fff",
                width: "100%",
                maxWidth: "350px",
                boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
            }}
        >
            <p
                style={{
                    fontWeight: "800",
                    fontSize: "14px",
                    marginBottom: "2px",
                }}
            >
                {title}
            </p>

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "10px",
                    flexWrap: "nowrap",
                    overflow: "hidden",
                }}
            >
                <div
                    style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "6px",
                        flex: "1",
                        minWidth: "0",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span
                            style={{
                                width: "8px",
                                height: "8px",
                                backgroundColor: "#CBD5E1",
                                borderRadius: "50%",
                                marginRight: "6px",
                                flexShrink: 0,
                            }}
                        ></span>

                        <span
                            style={{
                                fontSize: "12px",
                                fontWeight: "600",
                                flexShrink: 0,
                                marginRight: "4px",
                            }}
                        >
                            Timeliness:
                        </span>

                        <span
                            style={{
                                color: color1,
                                fontSize: "12px",
                                fontWeight: "600",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {timeliness}%
                        </span>
                    </div>

                    <div style={{ display: "flex", alignItems: "center" }}>
                        <span
                            style={{
                                width: "8px",
                                height: "8px",
                                backgroundColor: "#CBD5E1",
                                borderRadius: "50%",
                                marginRight: "6px",
                                flexShrink: 0,
                            }}
                        ></span>

                        <span
                            style={{
                                fontSize: "12px",
                                fontWeight: "600",
                                marginRight: "4px",
                                flexShrink: 0,
                            }}
                        >
                            Accuracy:
                        </span>

                        <span
                            style={{
                                color: color2,
                                fontSize: "12px",
                                fontWeight: "600",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {accuracy}%
                        </span>
                    </div>
                </div>
                <div
                    style={{
                        flexShrink: 0, 
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        marginLeft: "10px",
                    }}
                >
                    <DualCircleProgress
                        timeliness={timeliness}
                        accuracy={accuracy}
                        color1={color1}
                        color2={color2}
                    />
                </div>
            </div>
        </div>
    );
};

export default HorizentalTileCardDual;
